import React from 'react';
import {Dialog} from '@bosch/react-frok';
import {ValidationMessageType} from '../../models/ValidationMessageType';
import {ValidationMessage} from '../../models/ValidationMessage';
import {exists, t} from 'i18next';
import {generateIdentifier} from '../../utils/IdentityUtils';

export interface ErrorDialogProps {
    readonly populate: boolean,
    readonly headline: string | undefined,
    readonly description: string | undefined
    onChange: (populated: boolean) => void;
}

export const getErrorTypeStyle = (errorType: ValidationMessageType) => {
    let label = 'errorTypeLabel ';
    switch (errorType) {
        case ValidationMessageType.ERROR:
            return label.concat('errorTypeErrorColor');
        case ValidationMessageType.WARNING:
            return label.concat('errorTypeWarningColor');
        case ValidationMessageType.INFO:
            return label.concat('errorTypeInfoColor');
        default:
            return label.concat('errorTypeErrorColor');
    }
};

export const getErrorMessage = (validationMessage: ValidationMessage) => {
    if (!exists(validationMessage.keyCode)) {
        return <span id={generateIdentifier()}>{validationMessage.key}</span>
    }

    if ((validationMessage.params) && ((validationMessage.params.length > 0))) {
        return (
            <span id={generateIdentifier()}>
                {t(validationMessage.keyCode, {
                    param1: validationMessage.params[0] ? validationMessage.params[0].toString() : '',
                    param2: validationMessage.params[1] ? validationMessage.params[1].toString() : '',
                    param3: validationMessage.params[2] ? validationMessage.params[2].toString() : '',
                    param4: validationMessage.params[3] ? validationMessage.params[3].toString() : '',
                    param5: validationMessage.params[4] ? validationMessage.params[4].toString() : ''
                })}
            </span>
        );
    }

    return <span id={generateIdentifier()}>{t(validationMessage.keyCode)}</span>
};

export const setErrorDescription = (validationMessages?: ValidationMessage[]) => {
    if ((!validationMessages) || ((validationMessages.length === 0))) {
        return undefined;
    }

    return (
        <div id={generateIdentifier('errorMessageWrapper')}>
            <table id={generateIdentifier('errorMessageTable')}>
                {validationMessages.map(validationMessage =>
                    <tr id={generateIdentifier()} key={validationMessage.keyCode}>
                        <td id={generateIdentifier()} className='errorTypeTableColumn'>
                            <span id={generateIdentifier()}
                                  className={getErrorTypeStyle(validationMessage.type)}>{t(validationMessage.type)}
                            </span>
                        </td>
                        <td id={generateIdentifier()}
                            className='errorDescriptionTableColumn'>{getErrorMessage(validationMessage)}</td>
                    </tr>
                )}
            </table>
        </div>
    ) as unknown as string;
};

export const ErrorDialogue: React.VFC<ErrorDialogProps> = (props) => {
    if (props.populate) {
        return (
            <Dialog id={generateIdentifier()}
                    open
                    modal
                    title={t('GENERAL_ERROR_TITLE')}
                    headline={props.headline ?? t('GENERAL_ERROR_HEADER')}
                    dialogCode={props.description ?? t('HINT_GENERAL_ERROR')}
                    variant='error'
                    confirmLabel={t('GENERAL_OK_LABEL')}
                    onConfirm={() => props.onChange(false)}
                    onClose={() => props.onChange(false)}/>
        );
    }

    return <div id={generateIdentifier()}/>
};